"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _themeProvider = require("@gravity/theme-provider");
var _utils = require("@gravity/utils");
var _buttonEvolutionStyles = _interopRequireDefault(require("./buttonEvolutionStyles"));
var _buttonStyles = _interopRequireDefault(require("./buttonStyles"));
function cov_17orl03nha() {
  var path = "/codebuild/output/src3108803385/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/ui/Button/lib/StyledButton.js";
  var hash = "8c816729ae58e74561879ce4488a0f4076b8a557";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src3108803385/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/ui/Button/lib/StyledButton.js",
    statementMap: {
      "0": {
        start: {
          line: 9,
          column: 21
        },
        end: {
          line: 17,
          column: 1
        }
      },
      "1": {
        start: {
          line: 11,
          column: 24
        },
        end: {
          line: 11,
          column: 37
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 11,
            column: 15
          },
          end: {
            line: 11,
            column: 16
          }
        },
        loc: {
          start: {
            line: 11,
            column: 24
          },
          end: {
            line: 11,
            column: 37
          }
        },
        line: 11
      }
    },
    branchMap: {},
    s: {
      "0": 0,
      "1": 0
    },
    f: {
      "0": 0
    },
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "8c816729ae58e74561879ce4488a0f4076b8a557"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_17orl03nha = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_17orl03nha();
var StyledButton = (cov_17orl03nha().s[0]++, (0, _utils.withThemedStyles)(_styledComponents.default.button.attrs({
  className: function className(props) {
    cov_17orl03nha().f[0]++;
    cov_17orl03nha().s[1]++;
    return props.clsName;
  }
}), (0, _defineProperty2.default)((0, _defineProperty2.default)({}, _themeProvider.TicketShopTheme.EQUILIBRIUM, _buttonStyles.default), _themeProvider.TicketShopTheme.EVOLUTION, _buttonEvolutionStyles.default)));
var _default = exports.default = StyledButton;